module.exports = __webpack_public_path__ + "img/avatar3.d6a32db3.png";